const routes = {
	flow: process.env.REACT_APP_FLOW_IFRAME_URL || "http://localhost:8002",
	notification: process.env.REACT_APP_NOTIFICATION_IFRAME_URL || "http://localhost:8001",
	widget: process.env.REACT_APP_IFRAME_URL || "http://localhost:8000",
};

export default {
	routes,
	frameId: {
		flow: "Bothive_flows",
		notification: "Bothive_notification",
		widget: "Bothive_widget",
	},
	frameConfig: {
		flow: {
			title: "Bothive flows",
		},
		widget: {
			title: "Chat widget",
		},
		notification: {
			title: "Chat notification",
		},
	},
};
